"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferenceListInputCell = exports.StatefulDatePicker = exports.LinkInputCell = exports.CausalityInputCell = exports.RelationInputCell = exports.InputMeasurementCell = exports.InputInteger = exports.InputMultiSelect = exports.InputNumber = exports.Checkbox3List = exports.Checkbox3 = exports.InputText = void 0;
var React = require("react");
var causality_1 = require("../riskPage/causality");
var mobx_react_1 = require("mobx-react");
var combobox_1 = require("../lib/combobox");
var lists_1 = require("../lib/lists");
var multiSelect_1 = require("../lib/multiSelect");
var utils_1 = require("../../utils");
var typestyle_1 = require("typestyle");
var react_datepicker_1 = require("react-datepicker");
var moment = require("moment");
var config_1 = require("../../config");
var referenceList_1 = require("../references/referenceList");
var InputCell = (function (_super) {
    __extends(InputCell, _super);
    function InputCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InputCell.prototype.onClickOutside = function (e) {
        if ($(this._htmlElement).find(e.target).length > 0) {
            return;
        }
        $(document).off('click', this._currentOutsideClickHandler);
        this.props.onBlur && this.props.onBlur();
    };
    InputCell.prototype.render = function () {
        var _this = this;
        var props = this.props;
        return (React.createElement("div", { className: props.className, ref: function (me) {
                if (me && !_this._htmlElement) {
                    _this._htmlElement = me;
                    $(document).click();
                    _this._currentOutsideClickHandler = _this.onClickOutside.bind(_this);
                    $(document).click(_this._currentOutsideClickHandler);
                }
            } }, props.children));
    };
    return InputCell;
}(React.Component));
var InputText = (function (_super) {
    __extends(InputText, _super);
    function InputText(props) {
        var _this = _super.call(this, props) || this;
        _this._inputElement = null;
        _this.state = {
            value: props.value,
        };
        return _this;
    }
    InputText.prototype.componentDidMount = function () {
        if (this._inputElement) {
            var me = this._inputElement;
            var maxWidth = this.props.maxWidth || 500;
            if (this.props.autofocus && me) {
                me.focus();
            }
            if (this.props.disableScroll && me) {
                me.style.overflowY = "auto";
                me.style.minHeight = "";
                me.style.minHeight = (me.scrollHeight + 5) + "px";
            }
        }
    };
    InputText.prototype.keepState = function (newValue) {
        this.setState({
            value: newValue,
        });
    };
    InputText.prototype.render = function () {
        var _this = this;
        var props = this.props;
        return (React.createElement("textarea", { name: props.name, value: this.state.value, className: (0, typestyle_1.classes)("form-control", props.className), maxLength: props.maxLength, onChange: function (e) {
                _this.keepState.bind(_this)(e.target.value);
            }, onBlur: function (e) {
                props.onSubmit && props.onSubmit(props.name, _this.state.value);
            }, ref: function (me) {
                if (me && props.autofocus) {
                    me.focus();
                }
                if (me && !_this._inputElement)
                    _this._inputElement = me;
            } }));
    };
    return InputText;
}(React.Component));
exports.InputText = InputText;
var Checkbox3 = (function (_super) {
    __extends(Checkbox3, _super);
    function Checkbox3(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            changeHasFired: false
        };
        return _this;
    }
    Checkbox3.prototype.render = function () {
        var _this = this;
        var labelText = this.props.labelText;
        var cropped = false;
        var radioButtons = !!this.props.useRadioButtons;
        if (this.props.maxTextLength && labelText.length > this.props.maxTextLength) {
            labelText = labelText.substring(0, this.props.maxTextLength) + "...";
            cropped = true;
        }
        return (React.createElement("label", { className: this.props.labelClass, title: cropped ? this.props.suggestion : null },
            React.createElement("input", { type: radioButtons ? "radio" : "checkbox", value: this.props.value, id: this.props.id, className: this.props.className, name: this.props.name, ref: function (input) {
                    if (input) {
                        input.checked = _this.props.checked;
                        input.indeterminate = _this.props.indeterminate;
                        input.disabled = _this.props.disabled;
                    }
                }, onChange: function (e) {
                    if (!_this.props.disabled && _this.props.onChange)
                        _this.props.onChange(e);
                }, onClick: this.onClick.bind(this) }),
            " ",
            labelText));
    };
    Checkbox3.prototype.onClick = function () {
        var indeterminate = this.props.indeterminate;
        var changeHasFired = this.state.changeHasFired;
        if (indeterminate && (0, utils_1.isInternetExplorer)() && !changeHasFired) {
            this.setState({ changeHasFired: true });
            var fakeEvent = ({
                currentTarget: {
                    value: this.props.value,
                    checked: true,
                }
            });
            this.props.onChange(fakeEvent);
        }
    };
    return Checkbox3;
}(React.Component));
exports.Checkbox3 = Checkbox3;
var Checkbox3List = (function (_super) {
    __extends(Checkbox3List, _super);
    function Checkbox3List() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Checkbox3List.prototype.render = function () {
        var _this = this;
        return (React.createElement("ul", null,
            React.createElement(InputCell, { autofocus: this.props.autofocus, onBlur: this.props.onSubmit }, this.props.checkboxes.map(function (checkboxProps, index) {
                return (React.createElement("li", { key: index },
                    React.createElement(Checkbox3, { checked: checkboxProps.checked, indeterminate: checkboxProps.indeterminate, value: checkboxProps.value, disabled: checkboxProps.disabled, className: checkboxProps.className, id: checkboxProps.id, name: checkboxProps.name, labelText: checkboxProps.labelText, onChange: checkboxProps.onChange, useRadioButtons: _this.props.useRadioButtons })));
            }))));
    };
    return Checkbox3List;
}(React.PureComponent));
exports.Checkbox3List = Checkbox3List;
var InputNumber = function (props) {
    return (React.createElement("input", { type: "text", pattern: props.pattern ? props.pattern : "[0-9]*", placeholder: props.placeholder, value: props.value, className: (0, typestyle_1.classes)("form-control", props.className), onChange: props.onChange, ref: function (me) {
            if (me && props.autofocus)
                me.focus();
        }, onKeyDown: function (e) {
            if (e.keyCode == 13 && props.onSubmit)
                props.onSubmit();
        } }));
};
exports.InputNumber = InputNumber;
var InputMultiSelect = (function (_super) {
    __extends(InputMultiSelect, _super);
    function InputMultiSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            values: props.values
        };
        return _this;
    }
    InputMultiSelect.prototype.keepState = function (newValues) {
        this.setState({
            values: newValues,
        });
    };
    InputMultiSelect.prototype.render = function () {
        var _this = this;
        var props = this.props;
        return (React.createElement(multiSelect_1.Multiselect, { choices: props.choices, value: this.state.values, name: props.name, onChangeEvent: function (e) {
                _this.keepState(e.currentTarget.value);
            }, onClose: function () {
                props.onSubmit && props.onSubmit(props.name, _this.state.values);
            }, selectedText: gettext("item(s)"), noneSelectedText: gettext("select..."), classes: "gm--fullwidth" }));
    };
    return InputMultiSelect;
}(React.Component));
exports.InputMultiSelect = InputMultiSelect;
var InputInteger = (function (_super) {
    __extends(InputInteger, _super);
    function InputInteger(props) {
        var _this = _super.call(this, props) || this;
        _this._inputElement = null;
        _this.state = {
            value: props.value,
        };
        return _this;
    }
    InputInteger.prototype.componentDidMount = function () {
        if (this._inputElement) {
            var me = this._inputElement;
            if (this.props.autofocus && me) {
                me.focus();
            }
        }
    };
    InputInteger.prototype.keepState = function (value) {
        var newValue = parseInt(value);
        this.setState({
            value: newValue,
        });
    };
    InputInteger.prototype.render = function () {
        var _this = this;
        var props = this.props;
        return (React.createElement("input", { name: props.name, type: "number", defaultValue: props.value.toString(), className: (0, typestyle_1.classes)("form-control", props.className), onChange: function (e) {
                _this.keepState.bind(_this)(e.target.value);
            }, onBlur: function (e) {
                props.onSubmit && props.onSubmit(props.name, _this.state.value);
            }, ref: function (me) {
                if (me && props.autofocus) {
                    me.focus();
                }
                if (me && !_this._inputElement)
                    _this._inputElement = me;
            } }));
    };
    return InputInteger;
}(React.Component));
exports.InputInteger = InputInteger;
var InputMeasurementCell = (function (_super) {
    __extends(InputMeasurementCell, _super);
    function InputMeasurementCell(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            currentValue: props.value ? props.value.toString() : null,
        };
        return _this;
    }
    InputMeasurementCell.prototype.onClickOutside = function (e) {
        if ($(this._htmlElement).find(e.target).length > 0) {
            return;
        }
        $(document).off('click', this._currentOutsideClickHandler);
        if (this.props.onSubmit)
            this.props.onSubmit(this.state.currentValue);
    };
    InputMeasurementCell.prototype.render = function () {
        var _this = this;
        var props = this.props;
        return (React.createElement("div", { className: "InputMeasurementCell input-group", ref: function (me) {
                if (me && !_this._htmlElement) {
                    _this._htmlElement = me;
                    $(document).click();
                    _this._currentOutsideClickHandler = _this.onClickOutside.bind(_this);
                    $(document).click(_this._currentOutsideClickHandler);
                }
            } },
            React.createElement(exports.InputNumber, { className: "form-control", pattern: "^[\\-+]?[\\d]*[\\.]?[\\d]*$", placeholder: "0.000", value: this.state.currentValue, autofocus: props.autofocus, onChange: function (e) {
                    _this.setState({
                        currentValue: e.currentTarget.value,
                    });
                }, onSubmit: function () {
                    if (_this.props.onSubmit) {
                        _this.props.onSubmit(_this.state.currentValue);
                        $(document).off('click', _this._currentOutsideClickHandler);
                    }
                } }),
            React.createElement("div", { className: "input-group-append" },
                React.createElement("span", { className: "input-group-text" }, props.unit))));
    };
    return InputMeasurementCell;
}(React.Component));
exports.InputMeasurementCell = InputMeasurementCell;
var RelationInputCell = (function (_super) {
    __extends(RelationInputCell, _super);
    function RelationInputCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RelationInputCell.prototype.getListItemContent = function (obj) {
        return React.createElement(React.Fragment, null, obj.toString());
    };
    RelationInputCell.prototype.render = function () {
        var props = this.props;
        return (React.createElement(InputCell, { autofocus: true, onBlur: props.onBlur },
            React.createElement(combobox_1.AsyncComboBox, { value: "", options: [], onChange: props.handleAttach, placeholder: gettext("Search"), fetchSuggestions: props.fetchSuggestions }),
            React.createElement(lists_1.ListObjects, { objects: props.rowItems, detachable: true, deletable: false, editable: !!props.handleEdit, handleEdit: props.handleEdit, handleDetach: props.handleDelete, getListItemContent: this.getListItemContent.bind(this), groupByFunc: props.groupByFunc, sortObjects: props.sortObjects })));
    };
    return RelationInputCell;
}(React.Component));
exports.RelationInputCell = RelationInputCell;
var CausalityInputCell = (function (_super) {
    __extends(CausalityInputCell, _super);
    function CausalityInputCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CausalityInputCell.prototype.getListItemContent = function (causality) {
        return React.createElement(causality_1.CausalityDisplay, { causality: causality, maxTextLength: this.props.maxTextLength });
    };
    CausalityInputCell = __decorate([
        mobx_react_1.observer
    ], CausalityInputCell);
    return CausalityInputCell;
}(RelationInputCell));
exports.CausalityInputCell = CausalityInputCell;
var LinkInputCell = (function (_super) {
    __extends(LinkInputCell, _super);
    function LinkInputCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LinkInputCell.prototype.getListItemContent = function (link) {
        return (React.createElement("span", { className: "DomainItemBox DomainItemBox--risk" }, this.props.showTitles ?
            "#".concat(link.number, ": ").concat(link.title) :
            "".concat(link.number)));
    };
    LinkInputCell = __decorate([
        mobx_react_1.observer
    ], LinkInputCell);
    return LinkInputCell;
}(RelationInputCell));
exports.LinkInputCell = LinkInputCell;
var StatefulDatePicker = (function (_super) {
    __extends(StatefulDatePicker, _super);
    function StatefulDatePicker(props) {
        var _this = _super.call(this, props) || this;
        var date = "";
        if (props.defaultValue && moment(props.defaultValue).isValid())
            date = moment(props.defaultValue).format(config_1.ISO_DATE_FORMAT);
        else if (props.defaultSelected && props.defaultSelected.isValid())
            date = props.defaultSelected.format(config_1.ISO_DATE_FORMAT);
        _this.state = {
            currentDate: date,
        };
        return _this;
    }
    StatefulDatePicker.prototype.onChange = function (date, event) {
        var newDate = "";
        if (date instanceof moment)
            newDate = date.format(config_1.ISO_DATE_FORMAT);
        this.setState({
            currentDate: newDate,
        });
        this.props.onChange && this.props.onChange(date, event);
    };
    StatefulDatePicker.prototype.onChangeRaw = function (event) {
        this.setState({
            currentDate: event.currentTarget.value,
        });
        if (event.currentTarget.value == "")
            this.onChange(null, event);
        this.props.onChangeRaw && this.props.onChangeRaw(event);
    };
    StatefulDatePicker.prototype.render = function () {
        return React.createElement(react_datepicker_1.default, __assign({ dateFormat: config_1.ISO_DATE_FORMAT, value: this.state.currentDate }, this.props, { onChange: this.onChange.bind(this), onChangeRaw: this.onChangeRaw.bind(this) }));
    };
    return StatefulDatePicker;
}(React.Component));
exports.StatefulDatePicker = StatefulDatePicker;
var ReferenceListInputCell = (function (_super) {
    __extends(ReferenceListInputCell, _super);
    function ReferenceListInputCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReferenceListInputCell.prototype.render = function () {
        var props = this.props;
        return (React.createElement(InputCell, { autofocus: true, onBlur: props.onBlur },
            React.createElement(referenceList_1.ReferenceList, { referredObject: props.referredObject, references: props.references, editable: true, deletable: true, onEditClick: props.onEditClick, onDeleteClick: props.onDeleteClick })));
    };
    return ReferenceListInputCell;
}(React.Component));
exports.ReferenceListInputCell = ReferenceListInputCell;
